import { render, staticRenderFns } from "./salesteamlead_header.vue?vue&type=template&id=3ecdf59a&scoped=true&"
import script from "./salesteamlead_header.vue?vue&type=script&lang=js&"
export * from "./salesteamlead_header.vue?vue&type=script&lang=js&"
import style0 from "./salesteamlead_header.vue?vue&type=style&index=0&id=3ecdf59a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecdf59a",
  null
  
)

export default component.exports